import type { MaybeRefOrGetter } from 'vue'
import useApi from '../../components/js/Composables/useApi'
import type { ElectronicInvoiceStatusHistory } from '../../Types/invoice'
import { toValue } from 'vue'

export function useElectronicInvoiceStatusHistory(invoiceId: MaybeRefOrGetter<number | null>) {
  const { getJSON } = useApi()

  async function getHistories(): Promise<ElectronicInvoiceStatusHistory[]> {
    const id = toValue(invoiceId)
    if (!id) {
      return []
    }

    return await getJSON(`electronic-invoices/${id}/status-histories`)
  }

  return {
    getHistories,
  }
}
